(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ua-image-zoom"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){const link=event.target.closest('[data-ua-image-zoom]');if(link){const section=link.closest('product-form');const dialog=section?.querySelector('.ua-image-zoom');if(!dialog)return;event.preventDefault();const image=dialog.querySelector('img');image.src=link.href;image.alt=link.querySelector('img')?.alt||'';dialog.showModal();return}const close=event.target.closest('.ua-image-zoom__close');if(close)close.closest('dialog').close();if(event.target.matches('dialog.ua-image-zoom')){const box=event.target.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)event.target.close()}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ua-scent-finder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ua-scent-finder')) {
  customElements.define('ua-scent-finder', class extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true });
      } else {
        this.initialize();
      }
    }
    initialize() {
      if (this.initialized) return;
      this.initialized = true;
      const input = this.querySelector('[data-finder-search]');
      const choices = Array.from(this.querySelectorAll('button[data-family]'));
      const cards = Array.from(this.querySelectorAll('[data-finder-result]'));
      const status = this.querySelector('[data-finder-status]');
      const normalise = value => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
      let family = '';
      const update = () => {
        const terms = normalise(input.value).split(' ').filter(Boolean);
        const matches = cards.filter(card => (!family || card.dataset.family === family) && terms.every(term => normalise(card.dataset.search).includes(term)));
        cards.forEach(card => { card.hidden = true; });
        matches.slice(0, 6).forEach(card => { card.hidden = false; });
        status.textContent = matches.length === 1 ? status.dataset.oneLabel : matches.length ? Math.min(6, matches.length) + ' ' + status.dataset.countLabel : status.dataset.emptyLabel;
      };
      input.addEventListener('input', update);
      choices.forEach(button => button.addEventListener('click', () => {
        family = button.dataset.family;
        choices.forEach(choice => choice.setAttribute('aria-pressed', String(choice === button)));
        update();
      }));
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
